package com.patronat.top.ui.molecules.avatar

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import coil3.compose.AsyncImage
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.AvatarPlaceholderGray
import com.patronat.top.ui.theme.Primary500
import com.patronat.top.ui.theme.White

@Composable
fun EditableAvatar(
    imageUrl: Any?,
    initials: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    size: Dp = 86.dp
) {
    val badgeSize = size / 3f
    val iconSize = badgeSize / 1.8f
    val badgeBorderWidth = 2.dp

    Box(
        modifier = modifier
            .size(size)
            .clickable(onClick = onClick)
    ) {

        Box(
            modifier = Modifier
                .fillMaxSize()
                .clip(CircleShape)
                .background(AvatarPlaceholderGray),
            contentAlignment = Alignment.Center
        ) {
            if (imageUrl != null) {
                AsyncImage(
                    model = imageUrl,
                    contentDescription = "Avatar",
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.fillMaxSize()
                )
            } else {
                Text(
                    text = initials.uppercase().take(2),
                    color = White,
                    fontSize = (size.value / 3).sp,
                    fontWeight = FontWeight.Medium
                )
            }
        }

        Box(
            modifier = Modifier
                .align(Alignment.BottomEnd)
                // .offset(x = 2.dp, y = 2.dp) // Можна трохи зсунути, якщо треба "вилізти" за межі
                .size(badgeSize)
                // Білий бордюр, щоб відділити бейдж від фото
                .border(badgeBorderWidth, White, CircleShape)
                .clip(CircleShape)
                .background(Primary500), // Коричневий колір з теми
            contentAlignment = Alignment.Center
        ) {
            // Використовуйте вашу кастомну іконку з ресурсів.
            // Поки що для прикладу стоїть стандартна Material іконка.
            Icon(
                painter = AppIcons.Photo,
                contentDescription = "Змінити фото",
                tint = White,
                modifier = Modifier.size(iconSize)
            )
        }
    }
}